import swal from "sweetalert2";

/**
 * 
 * @param currentTimezoneCode - timezone code of report
 * @param newTimezoneCode - new timezone code of selected entity
 * @param fieldTitle - name of primary entity field
 */

export async function notifyTimezoneDiscrepancy(currentTimezoneCode, newTimezoneCode, fieldTitle) {
	try {
		await swal.fire({
			title: "Report timezone will be overridden on save.",
			html:
				`This report's timezone is currently ${currentTimezoneCode}.<br/><br/>
				Saving the report with the currently selected ${fieldTitle}
				will update the report's timezone to ${newTimezoneCode}`,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			showConfirmButton: true,
			type: "warning"
		});
	}catch(err) {
		return false;
	}
}